import { Box } from '@mantine/core';
import type { FC, FormEvent } from 'react';
import { useStepperOnboarding } from '../../context/StepperOnboardingContext';
import StepperAgentProfileCard from '../StepperAgentProfileCard';
import StepperSetupCompletePanel from '../StepperSetupCompletePanel';
import StepperSetupStepper from '../StepperSetupStepper';

const StepperOnboardingFormContent: FC = () => {
	const {
		closeTestCallModal,
		isSetupActivationVisible,
		isTestCallModalVisible,
		isTestCallWaitingVisible
	} = useStepperOnboarding();

	const handleFormSubmit = (event: FormEvent<HTMLFormElement>) => {
		event.preventDefault();
	};

	return (
		<Box
			component="form"
			noValidate
			onSubmit={handleFormSubmit}
		>
			<StepperAgentProfileCard />
			<StepperSetupStepper />
			<StepperSetupCompletePanel
				isActivationPanelVisible={isSetupActivationVisible}
				isTestCallModalVisible={isTestCallModalVisible}
				isWaitingStatusVisible={isTestCallWaitingVisible}
				onCloseTestCallModal={closeTestCallModal}
			/>
		</Box>
	);
};

export default StepperOnboardingFormContent;
